/* Docteur B — siret-obligatoire-2026-10-15 (Benoit 15/10/2026 : « tu peux imposer le SIRET pour toutes les commandes »).
   Aucune commande ne part sans SIRET valide dans l'attribut de panier « SIRET » : 14 chiffres + clé de Luhn
   (exception La Poste : SIREN 356000000, somme des chiffres multiple de 5).
   - Blocs [data-drb-siret] (snippet drb-siret) : panier, tiroir, page prélèvement, fenêtre de secours.
   - Pré-remplissage : SIRET de la société (drb.siret) s'il est valide -> posé sur le panier, rien à demander.
     SIREN seul (9 chiffres) -> les 9 chiffres sont pré-saisis, il manque les 5 du NIC ; proposition du SIRET du siège
     ou de l'établissement du code postal (recherche-entreprises.api.gouv.fr, données publiques).
   - Recherche par nom / code postal : portail /api/pharmacie?q=&cp= (FINESS + registre des sociétés).
   - Verrou : tout déclencheur de paiement (button/input name="checkout", lien /checkout) est intercepté tant que le
     SIRET n'est pas valide ; le champ visible est mis en avant, sinon une fenêtre le demande puis reprend le paiement.
   - Une fois saisi : écrit sur la fiche société s'il manquait (portail POST /api/siret, jeton client du thème).
   RIB et Kbis : non concernés, ils restent non bloquants. */
(function () {
  if (window.__drbSiretLoaded) return; window.__drbSiretLoaded = 1;
  var C = window.__drbSiret || {};
  var API = String(C.api || 'https://drb-compte-pharmacie.netlify.app').replace(/\/$/, '');
  var MSG = 'Indiquez le SIRET de l’officine (14 chiffres) : il est obligatoire pour facturer votre commande.';
  var d = function (v) { return String(v == null ? '' : v).replace(/\D/g, ''); };
  function luhn(s) { var t = 0; for (var i = 0; i < s.length; i++) { var n = +s.charAt(s.length - 1 - i); if (i % 2) { n *= 2; if (n > 9) n -= 9; } t += n; } return t % 10 === 0; }
  function siretOk(v) {
    v = d(v); if (v.length !== 14 || /^0+$/.test(v)) return false;
    if (v.indexOf('356000000') === 0) { var s = 0; for (var i = 0; i < 14; i++) s += +v.charAt(i); return s % 5 === 0; }
    return luhn(v);
  }
  function sirenOk(v) { v = d(v); return v.length === 9 && !/^0+$/.test(v) && (v === '356000000' || luhn(v)); }
  var fmt = function (v) { v = d(v); return v.length === 14 ? v.slice(0, 3) + ' ' + v.slice(3, 6) + ' ' + v.slice(6, 9) + ' ' + v.slice(9) : v; };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var titre = function (s) { return String(s || '').toLowerCase().replace(/(^|[\s\-'])(\S)/g, function (m, a, b) { return a + b.toUpperCase(); }); };

  var coSiret = d(C.coSiret);
  var etat = { v: siretOk(C.attr) ? d(C.attr) : '', pending: null, ecrits: {} };
  try { etat.ecrits = JSON.parse(sessionStorage.getItem('drbSiretEcrit') || '{}'); } catch (x) {}
  window.drbSiret = { ok: siretOk, siren: sirenOk, valeur: function () { return etat.v; } };

  /* --- enregistrement : attribut de panier, puis fiche société si elle n'a pas encore de SIRET valide --- */
  var tSave = null, enCours = null;
  function sauver(v) {
    clearTimeout(tSave);
    enCours = new Promise(function (ok) {
      tSave = setTimeout(function () {
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { SIRET: v } }) })
          .then(function () { ok(true); }, function () { ok(false); });
      }, 250);
    });
    ecrire(v);
    return enCours;
  }
  function ecrire(v) {
    if (!C.coId || !C.jeton || !C.email || siretOk(coSiret) || etat.ecrits[v]) return;
    etat.ecrits[v] = 1; try { sessionStorage.setItem('drbSiretEcrit', JSON.stringify(etat.ecrits)); } catch (x) {}
    try {
      fetch(API + '/api/siret', { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: C.email, jeton: C.jeton, companyId: String(C.coId), siret: v, source: 'panier' }) })
        .then(function (r) { return r.json(); }).then(function (j) { if (j && j.ecrit) coSiret = v; }).catch(function () {});
    } catch (x) {}
  }

  /* --- verrou visuel des boutons de paiement (le clic reste actif : il amène au champ) --- */
  var SEL = 'button[name="checkout"],input[name="checkout"],a[href^="/checkout"],a[href*="/checkouts/"]';
  function majVerrou() {
    var bloque = !etat.v;
    document.querySelectorAll(SEL).forEach(function (b) {
      b.classList.toggle('drb-siret-requis', bloque);
      if (bloque) { b.setAttribute('aria-disabled', 'true'); b.setAttribute('title', 'SIRET de l’officine requis'); }
      else if (b.getAttribute('title') === 'SIRET de l’officine requis') { b.removeAttribute('aria-disabled'); b.removeAttribute('title'); }
    });
    document.querySelectorAll('[data-drb-siret-etat]').forEach(function (e) {
      e.classList.toggle('is-ok', !!etat.v);
      var h = etat.v ? 'SIRET de l’officine : <b>' + esc(fmt(etat.v)) + '</b>'
        : '<b>SIRET de l’officine requis</b> avant le paiement · <a href="#drb-siret-zone" data-drb-siret-aller>l’indiquer</a>';
      if (e._h !== h) { e._h = h; e.innerHTML = h; }  /* pas de réécriture inutile : l'observateur de mutations ne doit pas boucler */
    });
  }

  /* --- un bloc de saisie --- */
  function init(box) {
    if (box._drbSiret) return; box._drbSiret = 1;
    var inp = box.querySelector('[data-drb-siret-input]'), msg = box.querySelector('[data-drb-siret-msg]'),
      okb = box.querySelector('[data-drb-siret-ok]'), aide = box.querySelector('[data-drb-siret-aidebox]'),
      prop = box.querySelector('[data-drb-siret-prop]'), ch = box.querySelector('[data-drb-siret-cherche]');
    if (!inp) return;
    var v0 = d(inp.value);
    if (etat.v && !siretOk(v0)) inp.value = etat.v;
    else if (!d(inp.value) && sirenOk(coSiret)) inp.value = coSiret;
    function dire(type, html) {
      msg.className = 'drb-siret__msg' + (type ? ' is-' + type : '');
      msg.innerHTML = html + (type === 'ok' ? '' : ' <button type="button" class="drb-siret__lien" data-drb-siret-aide>Où le trouver ?</button>');
    }
    function evaluer(fort) {
      var v = d(inp.value), ok = siretOk(v);
      box.classList.toggle('is-ok', ok); okb.hidden = !ok; inp.setAttribute('aria-invalid', !ok && (v.length >= 14 || fort) ? 'true' : 'false');  /* SIREN en cours de complétion : pas de rouge */
      if (ok) {
        dire('ok', 'SIRET enregistré pour cette commande.');
        if (etat.v !== v) { etat.v = v; sauver(v); document.querySelectorAll('[data-drb-siret-input]').forEach(function (i) { if (i !== inp && d(i.value) !== v) { i.value = v; if (i._drbEval) i._drbEval(); } }); }
        majVerrou(); if (box._pret) box._pret(); return true;
      }
      if (etat.v && d(etat.v) !== v) { etat.v = ''; majVerrou(); }
      if (v.length === 9 && sirenOk(v)) dire(fort ? 'err' : 'info', 'SIREN ' + esc(v.replace(/(\d{3})(?=\d)/g, '$1 ')) + ' : ajoutez les 5 derniers chiffres (NIC) de l’officine pour obtenir le SIRET à 14 chiffres.');
      else if (v.length === 14) dire('err', 'Ce numéro n’est pas un SIRET valide : vérifiez les 14 chiffres (ils figurent sur le Kbis et sur vos factures).');
      else if (v.length > 14) dire('err', 'Un SIRET compte 14 chiffres : vérifiez le numéro saisi.');
      else dire(fort ? 'err' : '', MSG);
      return false;
    }
    inp._drbEval = evaluer;
    inp.addEventListener('input', function () { evaluer(false); });
    inp.addEventListener('change', function () { evaluer(false); });
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); evaluer(true); } });
    box.addEventListener('click', function (e) {
      var a = e.target.closest('[data-drb-siret-aide]'); if (a) { e.preventDefault(); aide.hidden = !aide.hidden; if (!aide.hidden && ch) { ch.hidden = false; preRemplir(); } return; }
      var u = e.target.closest('[data-drb-siret-utiliser]'); if (u) { e.preventDefault(); inp.value = u.getAttribute('data-drb-siret-utiliser'); evaluer(true); prop.hidden = true; if (ch) ch.hidden = true; aide.hidden = true; return; }
      var g = e.target.closest('[data-drb-siret-go]'); if (g) { e.preventDefault(); chercher(); }
    });
    box._evaluer = evaluer;

    /* proposition depuis le SIREN connu de la société (siège ou établissement du code postal de livraison) */
    function proposerDepuisSiren(siren, sansCp) {
      if (!sansCp) { if (box._siren === siren) return; box._siren = siren; }
      var cp = sansCp ? '' : d(C.coCp);
      fetch('https://recherche-entreprises.api.gouv.fr/search?q=' + siren + '&page=1&per_page=1' + (cp.length === 5 ? '&code_postal=' + cp : ''))
        .then(function (r) { return r.json(); }).then(function (j) {
          var r = j && j.results && j.results[0];
          if (!r || r.siren !== siren) { if (cp && !sansCp) proposerDepuisSiren(siren, true); return; }
          var cands = (r.matching_etablissements || []).filter(function (e) { return e.etat_administratif === 'A' && siretOk(e.siret); });
          if (!cands.length && r.siege && r.siege.etat_administratif === 'A' && siretOk(r.siege.siret)) cands = [r.siege];
          if (!cands.length || siretOk(inp.value)) return;
          prop.innerHTML = '<span>Proposition d’après le registre des entreprises :</span>' + cands.slice(0, 3).map(function (e) {
            return '<button type="button" class="drb-siret__choix" data-drb-siret-utiliser="' + esc(e.siret) + '"><b>' + esc(fmt(e.siret)) + '</b><small>' +
              esc(titre(r.nom_complet || '')) + ' · ' + esc([e.code_postal, titre(e.libelle_commune || '')].filter(Boolean).join(' ')) + '</small><i>Utiliser ce SIRET</i></button>';
          }).join('');
          prop.hidden = false;
        }).catch(function () {});
    }
    /* recherche par nom et code postal (FINESS + registre des sociétés, via le portail) */
    function preRemplir() {
      var q = ch.querySelector('[data-drb-siret-q]'), cp = ch.querySelector('[data-drb-siret-cp]');
      if (q && !q.value && C.coNom) q.value = C.coNom;
      if (cp && !cp.value && C.coCp) cp.value = C.coCp;
    }
    function chercher() {
      var q = (ch.querySelector('[data-drb-siret-q]').value || '').trim(), cp = (ch.querySelector('[data-drb-siret-cp]').value || '').trim(),
        out = ch.querySelector('[data-drb-siret-res]');
      var qn = q.normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().replace(/^\s*(GRANDE\s+)?PHARMACIES?\s+(DE\s+LA|DE\s+L'|DU|DES|DE|D')?\s*/i, '').trim();
      if (qn.length < 3 && cp.length < 5) { out.innerHTML = '<p class="drb-siret__note">Indiquez au moins 3 lettres du nom ou un code postal.</p>'; return; }
      out.innerHTML = '<p class="drb-siret__note">Recherche…</p>';
      fetch(API + '/api/pharmacie?q=' + encodeURIComponent(qn) + '&cp=' + encodeURIComponent(cp)).then(function (r) { return r.json(); }).then(function (j) {
        var res = ((j && j.resultats) || []).filter(function (p) { return siretOk(p.siret); });
        out.innerHTML = res.length ? res.slice(0, 8).map(function (p) {
          return '<button type="button" class="drb-siret__choix" data-drb-siret-utiliser="' + esc(d(p.siret)) + '"><b>' + esc(titre(p.nom)) + '</b><small>' +
            esc([titre(p.adresse), p.cp, titre(p.ville)].filter(Boolean).join(' · ')) + ' · SIRET ' + esc(fmt(p.siret)) + '</small><i>C’est nous</i></button>';
        }).join('') : '<p class="drb-siret__note">Aucune officine trouvée avec un SIRET. Vérifiez le code postal, essayez un seul mot du nom, ou consultez votre Kbis.</p>';
      }).catch(function () { out.innerHTML = '<p class="drb-siret__note">Recherche indisponible pour le moment : le SIRET figure sur votre Kbis et vos factures.</p>'; });
    }
    if (ch) ch.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); chercher(); } });

    var ok = evaluer(false);
    if (!ok) {
      var s9 = d(inp.value).slice(0, 9);
      if (sirenOk(s9)) proposerDepuisSiren(s9);
      else if (sirenOk(coSiret.slice(0, 9))) proposerDepuisSiren(coSiret.slice(0, 9));
    }
  }

  /* --- fenêtre de secours (paiement déclenché hors d'un bloc visible : notification panier, autre gabarit) --- */
  var dlg = null;
  function fenetre(declencheur) {
    var tpl = document.getElementById('drb-siret-tpl'); if (!tpl) return false;
    if (!dlg) {
      dlg = document.createElement('div'); dlg.className = 'drb-siret-dlg'; dlg.setAttribute('role', 'dialog'); dlg.setAttribute('aria-modal', 'true'); dlg.setAttribute('aria-label', 'SIRET de l’officine');
      dlg.innerHTML = '<div class="drb-siret-dlg__box"><button type="button" class="drb-siret-dlg__x" aria-label="Fermer">×</button><p class="drb-siret-dlg__t">Avant le paiement</p>' + tpl.innerHTML +
        '<button type="button" class="button drb-siret-dlg__go" data-drb-siret-continuer disabled>Continuer vers le paiement</button></div>';
      document.body.appendChild(dlg);
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || e.target.closest('.drb-siret-dlg__x')) { dlg.hidden = true; return; }
        if (e.target.closest('[data-drb-siret-continuer]') && etat.v) {
          dlg.hidden = true; var b = etat.pending; etat.pending = null;
          Promise.resolve(enCours).then(function () { if (b && document.contains(b)) b.click(); else location.href = '/checkout'; });
        }
      });
      var box = dlg.querySelector('[data-drb-siret]');
      box._pret = function () { dlg.querySelector('[data-drb-siret-continuer]').disabled = false; };
      init(box);
    }
    etat.pending = declencheur; dlg.hidden = false;
    dlg.querySelector('[data-drb-siret-continuer]').disabled = !etat.v;
    var i = dlg.querySelector('[data-drb-siret-input]'); if (i) setTimeout(function () { i.focus(); }, 30);
    return true;
  }
  function visible(el) { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }
  function demander(declencheur) {
    var boxes = [].filter.call(document.querySelectorAll('[data-drb-siret]'), function (b) { return visible(b) && !b.closest('.drb-siret-dlg'); });
    var proche = declencheur && declencheur.closest && declencheur.closest('cart-drawer,[data-drb-cart],.drb-lcrp');
    var box = boxes.filter(function (b) { return proche && proche.contains(b); })[0] || boxes[0];
    if (box) {
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var i = box.querySelector('[data-drb-siret-input]'); if (i) setTimeout(function () { i.focus({ preventScroll: true }); }, 300);
      if (box._evaluer) box._evaluer(true);
      box.classList.remove('is-flash'); void box.offsetWidth; box.classList.add('is-flash');
      return;
    }
    if (!fenetre(declencheur)) alert(MSG);
  }
  function estPaiement(el) { return el && el.closest ? el.closest(SEL) : null; }
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('[data-drb-siret-aller]'); if (a) { ev.preventDefault(); demander(null); return; }
    var b = estPaiement(ev.target); if (!b || etat.v) return;
    ev.preventDefault(); ev.stopImmediatePropagation(); demander(b);
    if (window.drbEtape) window.drbEtape('siret_demande');
  }, true);
  document.addEventListener('submit', function (ev) {
    var s = ev.submitter; if (!s || s.name !== 'checkout' || etat.v) return;
    ev.preventDefault(); ev.stopImmediatePropagation(); demander(s);
  }, true);

  /* --- démarrage : SIRET valide de la société -> posé sur le panier sans rien demander --- */
  function start() {
    if (!etat.v && siretOk(coSiret)) { etat.v = coSiret; sauver(coSiret); }
    else if (etat.v && !siretOk(coSiret)) ecrire(etat.v);  /* SIRET déjà sur le panier, absent de la fiche : on le reporte */
    document.querySelectorAll('[data-drb-siret]').forEach(init);
    majVerrou();
    if (window.MutationObserver) {
      var t = null;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { document.querySelectorAll('[data-drb-siret]').forEach(init); majVerrou(); }, 60); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
